export default "__VITE_ASSET__CauPjJAz__"